// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ALBUM_DESCRIPTION_SHOW_MORE = "Zobraz viac";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
